module.exports = {
  /* eslint-disable */
  bingPixel: data => {
    (function(w, d, t, r, u) {
      var f, n, i;
      (w[u] = w[u] || []),
        (f = function() {
          var o = { ti: data.key };
          (o.q = w[u]), (w[u] = new UET(o)), w[u].push('pageLoad');
        }),
        (n = d.createElement(t)),
        (n.src = r),
        (n.async = 1),
        (n.onload = n.onreadystatechange = function() {
          var s = this.readyState;
          (s && s !== 'loaded' && s !== 'complete') ||
            (f(), (n.onload = n.onreadystatechange = null));
        }),
        (i = d.getElementsByTagName(t)[0]),
        i.parentNode.insertBefore(n, i);
    })(window, document, 'script', data.url, 'uetq');
  },
  everflow: data => {
    const efScript = document.createElement('script');
    efScript.type = 'text/javascript';
    efScript.src = data.url;
    document.head.appendChild(efScript);

    window.addEventListener('load', function(event) {
      EF.click({
        offer_id: EF.urlParameter('oid'),
        affiliate_id: EF.urlParameter('aid'),
        sub1: EF.urlParameter('sub1'),
        sub2: EF.urlParameter('sub2'),
        sub3: EF.urlParameter('sub3'),
        sub4: EF.urlParameter('sub4'),
        sub5: EF.urlParameter('sub5'),
        uid: EF.urlParameter('uid'),
        transaction_id: EF.urlParameter('transaction_id')
      });
    });
  },
  facebookPixel: data => {
    data.id = !Array.isArray(data.id)
      ? data.id.replace(/\s/g, '').split(',')
      : data.id;

    !(function(f, b, e, v, n, t, s) {
      if (f.fbq) return;
      n = f.fbq = function() {
        n.callMethod
          ? n.callMethod.apply(n, arguments)
          : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = '2.0';
      n.queue = [];
      t = b.createElement(e);
      t.async = !0;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t, s);
    })(window, document, 'script', data.url);

    for (let i = 0; i < data.id.length; i++) {
      fbq('init', data.id[i]);
    }

    fbq('track', 'PageView');
  },
  googleTag: data => {
    (function(w, d, s, l, i) {
      w[l] = w[l] || [];
      w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
      var f = d.getElementsByTagName(s)[0],
        j = d.createElement(s),
        dl = l != 'dataLayer' ? '&l=' + l : '';
      j.async = true;
      j.src = data.url + i + dl;
      f.parentNode.insertBefore(j, f);
    })(window, document, 'script', 'dataLayer', data.id);
  },
  gtm: data => {
    data.id = !Array.isArray(data.id)
      ? data.id.replace(/\s/g, '').split(',')
      : data.id;

    const gtmscript = document.createElement('script');
    const UNTAGGED_PROVIDER_IDS = ['521713', '521735'];

    gtmscript.src = data.url;
    document.head.appendChild(gtmscript);

    window.dataLayer = window.dataLayer || [];

    function gtag() {
      dataLayer.push(arguments);
    }
    gtag('js', new Date());

    // If from a provider we tag, add additional tracking to page
    if (!UNTAGGED_PROVIDER_IDS.includes(data.providerId)) {
      for (let i = 0; i < data.id.length; i++) {
        gtag('config', data.id[i]);
      }
    }
  },
  hotjar: data => {
    (function(h, o, t, j, a, r) {
      h.hj =
        h.hj ||
        function() {
          (h.hj.q = h.hj.q || []).push(arguments);
        };
      h._hjSettings = { hjid: 973470, hjsv: 6 };
      a = o.getElementsByTagName('head')[0];
      r = o.createElement('script');
      r.async = 1;
      r.src = t + h._hjSettings.hjid + j + h._hjSettings.hjsv;
      a.appendChild(r);
    })(window, document, data.url, '.js?sv=');
  },
  mightyHive: data => {
    let time = Math.round(new Date().getTime() / 1000);

    let src =
      data.url +
      data.remar +
      ';cat=remar' +
      data.remar +
      ';dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=;npa=;ord=' +
      time +
      '?';

    // Build Element
    const thisFrame = document.createElement('iframe');
    thisFrame.src = src;
    thisFrame.width = '1';
    thisFrame.height = '1';
    thisFrame.frameBorder = '0';
    thisFrame.style.display = 'none';

    // Add to page
    document.body.prepend(thisFrame);
  },
  outbrain: data => {
    /** DO NOT MODIFY THIS CODE**/
    !(function(_window, _document) {
      var OB_ADV_ID = data.id;
      if (_window.obApi) {
        var toArray = function(object) {
          return Object.prototype.toString.call(object) === '[object Array]'
            ? object
            : [object];
        };
        _window.obApi.marketerId = toArray(_window.obApi.marketerId).concat(
          toArray(OB_ADV_ID)
        );
        return;
      }
      var api = (_window.obApi = function() {
        api.dispatch
          ? api.dispatch.apply(api, arguments)
          : api.queue.push(arguments);
      });
      api.version = '1.1';
      api.loaded = true;
      api.marketerId = OB_ADV_ID;
      api.queue = [];
      var tag = _document.createElement('script');
      tag.async = true;
      tag.src = data.url;
      tag.type = 'text/javascript';
      var script = _document.getElementsByTagName('script')[0];
      script.parentNode.insertBefore(tag, script);
    })(window, document);
    obApi('track', 'PAGE_VIEW');
  },
  sift: data => {
    var _user_id =
      data.user_id; /* Set user id to '' or email to match user id when order is created */
    var _session_id =
      data.session_id; /* Set to a unique session ID for the visitor's current browsing session. */

    var _sift = (window._sift = window._sift || []);
    _sift.push(['_setAccount', data.id]);
    _sift.push(['_setUserId', _user_id]);
    _sift.push(['_setSessionId', _session_id]);
    _sift.push(['_trackPageview']);

    window.sendSiftPageView = () => {
      /* Method for use in Vue pages */
      _sift.push(['_trackPageview']);
    };

    (function() {
      function ls() {
        var e = document.createElement('script');
        e.src = data.url;
        document.body.appendChild(e);
      }
      if (window.attachEvent) {
        window.attachEvent('onload', ls);
      } else {
        window.addEventListener('load', ls, false);
      }
    })();
  },
  trustedPixel: data => {
    // Create Script Element
    const tspixelScript = document.createElement('script');
    // Add SRC
    tspixelScript.src = data.url;
    // Add Async
    tspixelScript.async = true;
    tspixelScript.type = 'text/javascript';
    // Add type to script jic
    document.head.appendChild(tspixelScript);
  },
  pushnami: data => {
    const pushnamiScript = document.createElement('script');
    pushnamiScript.src = data.url + data.id;
    pushnamiScript.type = 'text/javascript';
    document.head.appendChild(pushnamiScript);
  },
  vwo: data => {
    window._vwo_code = (function() {
      (window.account_id = data.id),
        (window.settings_tolerance = 2000),
        (window.library_tolerance = 2500),
        (window.use_existing_jquery = false),
        (window.is_spa = 1),
        /* DO NOT EDIT BELOW THIS LINE */
        (window.f = false),
        (window.d = document);
      return {
        use_existing_jquery: function() {
          return use_existing_jquery;
        },
        library_tolerance: function() {
          return library_tolerance;
        },
        finish: function() {
          if (!f) {
            f = true;
            var a = d.getElementById('_vis_opt_path_hides');
            if (a) a.parentNode.removeChild(a);
          }
        },
        finished: function() {
          return f;
        },
        load: function(a) {
          var b = d.createElement('script');
          b.src = a;
          b.type = 'text/javascript';
          b.innerText;
          b.onerror = function() {
            _vwo_code.finish();
          };
          d.getElementsByTagName('head')[0].appendChild(b);
        },
        init: function() {
          var settings_timer = setTimeout(
            '_vwo_code.finish()',
            settings_tolerance
          );
          var a = d.createElement('style'),
            b = '', // Removed style that causes page blink onload.
            h = d.getElementsByTagName('head')[0];
          a.setAttribute('id', '_vis_opt_path_hides');
          a.setAttribute('type', 'text/css');
          if (a.styleSheet) a.styleSheet.cssText = b;
          else a.appendChild(d.createTextNode(b));
          h.appendChild(a);
          this.load(
            data.url +
              account_id +
              '&u=' +
              encodeURIComponent(d.URL) +
              '&f=' +
              +is_spa +
              '&r=' +
              Math.random()
          );
          return settings_timer;
        }
      };
    })();
    window._vwo_settings_timer = _vwo_code.init();
  },
  googleAd: data => {
    function addScript() {
      var s = document.createElement('script');
      s.setAttribute('src', data.url);
      s.setAttribute('data-ad-client', data.id);
      s.setAttribute('async', '');
      document.body.appendChild(s);
    }

    (function() {
      setTimeout(addScript, 2000);
    })();
  },
  clarity: data => {
    (function(c,l,a,r,i,t,y){
      c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
      t=l.createElement(r);t.async=1;t.src=data.url + '' +i;
      y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
    })(window, document, "clarity", "script", data.id);
  }
  /* eslint-enable */
};
